import React, { useRef } from "react";
import { gsap, useGSAP, EASE, prefersReducedMotion } from "../../lib/gsap";

/**
 * A section rule that measures itself: the hairline draws across and the tick
 * marks drop in behind it, so every division in the layout reads as a scale
 * rather than a border.
 */
const Ruler = ({ ticks = 12, className = "", start = "top 94%" }) => {
  const scope = useRef(null);
  const marks = Array.from({ length: ticks });

  useGSAP(
    () => {
      if (prefersReducedMotion()) return undefined;

      const tl = gsap.timeline({
        scrollTrigger: { trigger: scope.current, start, once: true },
      });

      tl.from(scope.current.querySelector("[data-rule]"), {
        scaleX: 0,
        duration: 0.85,
        ease: EASE.io,
      }).from(
        scope.current.querySelectorAll("[data-tick]"),
        { scaleY: 0, duration: 0.3, stagger: 0.022, ease: EASE.out },
        0.18
      );

      return () => tl.kill();
    },
    { scope }
  );

  return (
    <div ref={scope} className={`relative w-full ${className}`} aria-hidden="true">
      <div
        data-rule
        className="h-px w-full origin-left"
        style={{ background: "var(--line-strong)" }}
      />
      <div className="flex justify-between">
        {marks.map((_, i) => (
          <span
            key={i}
            data-tick
            className="block w-px origin-top"
            style={{
              height: i % 4 === 0 ? 7 : 4,
              background: i % 4 === 0 ? "var(--flare)" : "var(--line-strong)",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default Ruler;
